import { useState } from 'react';

function CTASection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9sp4n58o1vn02ekujbg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setFormStatus('success');
        setEmail('');
      } else {
        const msg = (parsed as { meta?: { message?: string; detail?: string }; message?: string }).meta?.message
          || (parsed as { meta?: { message?: string; detail?: string }; message?: string }).meta?.detail
          || (parsed as { message?: string }).message
          || text
          || '提交失敗，請稍後再試。';
        setFormStatus('error');
        setFormError(String(msg));
      }
    } catch {
      setFormStatus('error');
      setFormError('網絡錯誤，請檢查連接後重試。');
    }
  };

  return (
    <section id="cta" className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20gradient%20background%20with%20soft%20golden%20and%20cream%20tones%2C%20luxurious%20texture%2C%20minimalist%20design%2C%20premium%20wellness%20brand%20aesthetic%2C%20subtle%20flowing%20shapes&width=1800&height=600&seq=xfb-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 to-background-950/50"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          立即開啟幸福之旅
        </h2>
        <p className="text-sm md:text-base text-background-300 mb-8 leading-relaxed max-w-xl mx-auto">
          現在訂購享限時優惠，正品保證，隱密包裝配送，讓您安心體驗性福寶帶來的改變
        </p>

        <form
          id="newsletter-form"
          data-readdy-form="true"
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
        >
          <div className="flex-1 w-full">
            <input
              type="email"
              name="email"
              placeholder="請輸入您的電子郵箱"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-md bg-background-50/95 text-foreground-900 text-sm placeholder:text-foreground-400 border border-background-200/50 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <button
            type="submit"
            className="bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer w-full sm:w-auto"
          >
            立即訂閱
          </button>
          <div className="honeypot-guard">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
        </form>

        {formStatus === 'success' && (
          <p className="text-sm text-green-400 mt-4">感謝您的訂閱！我們將盡快為您送上專屬優惠。</p>
        )}
        {formStatus === 'error' && (
          <p className="text-sm text-red-400 mt-4">{formError}</p>
        )}

        <p className="text-xs text-background-400 mt-4">
          訂閱即可獲得專屬優惠與最新產品資訊，我們尊重您的隱私
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          <div className="flex items-center gap-2 text-background-200 text-xs">
            <i className="ri-shield-check-line"></i>
            <span>正品保證</span>
          </div>
          <div className="flex items-center gap-2 text-background-200 text-xs">
            <i className="ri-lock-line"></i>
            <span>隱密包裝</span>
          </div>
          <div className="flex items-center gap-2 text-background-200 text-xs">
            <i className="ri-truck-line"></i>
            <span>快速配送</span>
          </div>
          <div className="flex items-center gap-2 text-background-200 text-xs">
            <i className="ri-refund-2-line"></i>
            <span>30天退換</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;